module.exports = __webpack_public_path__ + "media/images/ep1-cindy-6440c42a6bc7f634f3be53b3728e25c6.jpg";